import AdminUserManagementModal from './AdminUserManagementModal';

export default AdminUserManagementModal;
